import { dataInitialSgaProduct } from "./state";

/**
 * Establecer los datos del SGA 2 del producto par el filtro y datos.
 * 
 * @param Object state 
 * @param Object nextState 
 * @return void 
 */
export function setFilterProductSga2(state, nextState) {
    state.filterProductSga2 = nextState;
}

/**
 * Restablecer los datos del SGA 2 del producto.
 * 
 * Frases, Pictogramas y medidas.
 * 
 * @param Object state 
 * @return void 
 */
export function resetSga(state) {
    state.sga = dataInitialSgaProduct();
}

/**
 * Establecer los datos del SGA 2 del producto.
 * 
 * Frases, Pictogramas y medidas.
 * 
 * @param Object state 
 * @param Object nextState 
 * @return void 
 */
export function setSga(state, nextState) {
    state.sga = nextState;
}